import { Input } from '@frontapp/ui-kit';
import { omit } from 'lodash-es';
import type { FieldProps } from '../FieldWrapper';

export type Value = string | null;

export function TextInput({
  disabled,
  field,
  ...props
}: FieldProps<Value> & { placeholder?: string }) {
  return (
    <>
      <Input
        type="text"
        id={field.name}
        {...omit(props, ['form', 'meta'])}
        {...field}
        isDisabled={disabled}
        value={field.value || ''}
      />
    </>
  );
}
